import React from 'react';
import { withRouter, Link } from 'react-router-dom';
import { getClickAttrs } from '../Analytics/gtag';
import TrackedClick from '../Analytics/TrackedClick';

import styles from './menu.scss';

const MenuLink = (props) => {
    const { path, text, trackedContent, section, isLeagueLink = false } = props;
    const { pathname } = props.location;
    return (
        <TrackedClick
            eventName="Menu Cta Clicked"
            label={trackedContent || text}
            traits={
                {
                    sectionName: section || 'Menu',
                    content: trackedContent || text,
                }
}
        >
            {isLeagueLink ? (
                <a
                    href={path}
                    className={`${styles.menuItem} ${pathname === path ? styles.active : ''}`}
                    {...getClickAttrs({
                        category: 'Menu',
                        context: `Menu Item - ${text}`,
                        location: 'Menu',
                    })}
                >
                    {text}
                </a>
            ) : (
                <Link
                    className={`${styles.menuItem} ${pathname === path ? styles.active : ''}`}
                    to={path}
                    {...getClickAttrs({
                        category: 'Menu',
                        context: `Menu Item - ${text}`,
                        location: 'Menu',
                    })}
                >
                    {text}
                </Link>
            )}

        </TrackedClick>
    );
};

export default withRouter(MenuLink);
